export const enum TestIds {
  GRID = "grid-test-id",
  INTERACTIVE = "gridElement-test-id",
  INNER_DIAMOND = "innerDiamond-test-id",
  SQUARE_PART = "gridElement-part-test-id",
  ETIQUETTE = "etiquette-gridElement-test-id",
  DETAILS_WINDOW = "details-window-test-id",
  SEARCH_TXT_FIELD = "search-txt-field-test-id",
  SHORTUT = "shortcut-test-id",
}
